/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menu_ThemesInputs */

const bn_menu_themes = /** @type {(inputs: Menu_ThemesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`থিম`)
};

const de_menu_themes = /** @type {(inputs: Menu_ThemesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thema`)
};

const el_menu_themes = /** @type {(inputs: Menu_ThemesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Θέμα`)
};

const en_menu_themes = /** @type {(inputs: Menu_ThemesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theme`)
};

const es_menu_themes = /** @type {(inputs: Menu_ThemesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tema`)
};

const fr_menu_themes = /** @type {(inputs: Menu_ThemesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thème`)
};

const hi_menu_themes = /** @type {(inputs: Menu_ThemesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विषय`)
};

const hu_menu_themes = /** @type {(inputs: Menu_ThemesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téma`)
};

const id_menu_themes = /** @type {(inputs: Menu_ThemesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tema`)
};

const it_menu_themes = /** @type {(inputs: Menu_ThemesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tema`)
};

const ja_menu_themes = /** @type {(inputs: Menu_ThemesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テーマ`)
};

const ko_menu_themes = /** @type {(inputs: Menu_ThemesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주제`)
};

const nl_menu_themes = /** @type {(inputs: Menu_ThemesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thema`)
};

const pl_menu_themes = /** @type {(inputs: Menu_ThemesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temat`)
};

const pt_menu_themes = /** @type {(inputs: Menu_ThemesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tema`)
};

const ru_menu_themes = /** @type {(inputs: Menu_ThemesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тема`)
};

const sv_menu_themes = /** @type {(inputs: Menu_ThemesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tema`)
};

const tr_menu_themes = /** @type {(inputs: Menu_ThemesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tema`)
};

const uk_menu_themes = /** @type {(inputs: Menu_ThemesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тема`)
};

const vi_menu_themes = /** @type {(inputs: Menu_ThemesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`chủ đề`)
};

const zh_menu_themes = /** @type {(inputs: Menu_ThemesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主题`)
};

const zh_hant_menu_themes = /** @type {(inputs: Menu_ThemesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主題`)
};

/**
* | output |
* | --- |
* | "Theme" |
*
* @param {Menu_ThemesInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const menu_themes = /** @type {((inputs?: Menu_ThemesInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menu_ThemesInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_menu_themes(inputs)
	if (locale === "de") return de_menu_themes(inputs)
	if (locale === "el") return el_menu_themes(inputs)
	if (locale === "en") return en_menu_themes(inputs)
	if (locale === "es") return es_menu_themes(inputs)
	if (locale === "fr") return fr_menu_themes(inputs)
	if (locale === "hi") return hi_menu_themes(inputs)
	if (locale === "hu") return hu_menu_themes(inputs)
	if (locale === "id") return id_menu_themes(inputs)
	if (locale === "it") return it_menu_themes(inputs)
	if (locale === "ja") return ja_menu_themes(inputs)
	if (locale === "ko") return ko_menu_themes(inputs)
	if (locale === "nl") return nl_menu_themes(inputs)
	if (locale === "pl") return pl_menu_themes(inputs)
	if (locale === "pt") return pt_menu_themes(inputs)
	if (locale === "ru") return ru_menu_themes(inputs)
	if (locale === "sv") return sv_menu_themes(inputs)
	if (locale === "tr") return tr_menu_themes(inputs)
	if (locale === "uk") return uk_menu_themes(inputs)
	if (locale === "vi") return vi_menu_themes(inputs)
	if (locale === "zh") return zh_menu_themes(inputs)
	return zh_hant_menu_themes(inputs)
});